<script setup>
const props = defineProps({ placement: { type: String, required: true } });
const settings = useState('settings');
const targetId = computed(() => 'yandex_rtb_R-A-20123375-5-' + props.placement);
</script>

<template>
 <section v-if="!settings?.disableAdvertising" class="uo-post-content-ad" aria-label="Реклама" :data-ad-placement="placement">
  <AdContainer :id="targetId" block-id="R-A-20123375-5" type="feed" />
 </section>
</template>

<style scoped>
.uo-post-content-ad { width:100%; max-width:100%; min-width:0; margin-block:24px; }
</style>
